module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-05.84032823.jpg";